import angular from 'angular';

import {hasMyPortal} from 'acng/core/service/env';
import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate';

import {fskTrans} from './0fsk';
import nickname, {nicknameFilter} from './filter/nickname';
import idlePopup from './idle-popup';
import './attribute/index.js';
import './config/controller/if-myportal.js';
import ngModuleName from './config/feature.js';
import './matomo.js';
import {initialLogin} from '../user/auth/login.js';

export default ngModuleName;

angular
  .module(ngModuleName, [angularTranslate, 'stock', idlePopup])
  .config(provideTranslations(ngModuleName))
  .run(['$injector', '$location', initialLogin])
  .filter('fskTrans', () => fskTrans)
  .filter(nickname, nicknameFilter)
  .factory('isPortal', () => hasMyPortal);
